// Meta is grouped under "Control" for our use purposes hence why it's not listed here.
enum ModifierKey {
  Control = "Control",
  Alt = "Alt",
  Shift = "Shift",
}

enum CharKey {
  A = "a",
  B = "b",
  C = "c",
  D = "d",
  E = "e",
  F = "f",
  G = "g",
  H = "h",
  I = "i",
  J = "j",
  K = "k",
  L = "l",
  M = "m",
  N = "n",
  O = "o",
  P = "p",
  Q = "q",
  R = "r",
  S = "s",
  T = "t",
  U = "u",
  V = "v",
  X = "x",
  Y = "y",
  Z = "z",

  Enter = "Enter",
  Tab = "Tab",
  ArrowDown = "ArrowDown",
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",
  ArrowUp = "ArrowUp",
  PageEnd = "End",
  PageHome = "Home",
  ForwardSlash = "/",
  Period = ".",
  Comma = ",",
  Semicolon = ";",
  QuestionMark = "?",
  ExclamationMark = "!",
  BracketLeft = "[",
  BracketRight = "]",
}

export { ModifierKey, CharKey };
